import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]

import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {SwitchInputInterface} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";


const __default__ = {
    name: "ChatSwitchInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<SwitchInputInterface>()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject} = useChatFormInput(props);

__expose(exposedObject);

function onInput($event: any) {
    let value = $event.target.checked ? true : null;
    emits('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", null, [
    _createVNode(InputWrapperWithIcon, {
      field: _ctx.field,
      required: _ctx.required
    }, {
      icon: _withCtx(() => [
        _createElementVNode("input", {
          type: "checkbox",
          onChange: onInput,
          checked: _ctx.modelValue
        }, null, 40, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass({
                    'like-input': true,
                    'with-icon': true,
                    error: _ctx.error
                })
        }, [
          _createVNode(ChatHtmlify, {
            value: _unref(props).field.descrAfterSwitch,
            bbcode: "",
            nl2br: ""
          }, null, 8, ["value"]),
          _renderSlot(_ctx.$slots, "after-descr")
        ], 2)
      ]),
      _: 3
    }, 8, ["field", "required"])
  ]))
}
}

})